export enum ChatRoomType {
  CommunityManager = 'COMMUNITY_MANAGER',
  PersonalManager = 'PERSONAL_MANAGER',
  System = 'SYSTEM',
  Private = 'PRIVATE',
  Group = 'GROUP',
}
